import {
	Box,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Tooltip,
	Typography,
} from "@mui/material";
import { formatCurrency } from "../../utils";
import { formatEventDisplayName } from "../payments-import/payment-import-logic";

type PaymentForEvent = {
	id?: number;
	paypal_transaction_code: string | null;
	type: "paypal" | "cash";
	amount_cents: number;
	datetime: string | null;
	description: string | null;
};

type UserEvent = {
	event_id: number;
	event_date: string;
	participant_count: number;
	event_total_cost_cents: number;
	payments: PaymentForEvent[];
	paid_cents: number;
	outstanding_cents: number;
	fully_paid: boolean;
};

export default function EventPaymentsTable({
	events,
}: {
	events: UserEvent[];
}) {
	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>Datum</TableCell>
					<TableCell>Preis</TableCell>
					<TableCell>Gezahlt</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{events.map((ev) => {
					const costPerParticipant =
						ev.participant_count > 0
							? Math.round(ev.event_total_cost_cents / ev.participant_count)
							: ev.event_total_cost_cents;

					// Extract date without the relative time part
					const fullDisplayName = formatEventDisplayName({ date: ev.event_date });
					const match = fullDisplayName.match(/^(\d{2}\.\d{2}\.\d{4})(?: \((.*)\))?$/);
					const dateOnly = match ? match[1] : fullDisplayName;
					const relativeTime = match?.[2] || "";

					return (
						<TableRow key={ev.event_id}>
							<TableCell>
								<Tooltip title={relativeTime} arrow>
									<Typography>
										{dateOnly}
									</Typography>
								</Tooltip>
							</TableCell>
							<TableCell>{formatCurrency(costPerParticipant)}</TableCell>
							<TableCell>
								{(ev.payments ?? []).length === 0 ? (
									<Typography variant="body2">—</Typography>
								) : (
									<Stack spacing={0.5}>
										{ev.payments.map((p, idx) => {
											let paymentText = formatCurrency(p.amount_cents);
											if (p.type === "paypal" && p.datetime) {
												const date = new Date(p.datetime);
												const day = date.getDate().toString().padStart(2, "0");
												const month = (date.getMonth() + 1).toString().padStart(2, "0");
												paymentText += ` (PP am ${day}.${month})`;
											} else if (p.type === "paypal") {
												paymentText += " (PayPal)";
											} else {
												paymentText += " (Bar)";
											}
											return (
												<Box
													key={`${p.paypal_transaction_code ?? "cash"}-${idx}`}
												>
													<Typography variant="body2">
														{paymentText}
													</Typography>
												</Box>
											);
										})}
									</Stack>
								)}
							</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</Table>
	);
}
